// src/Components/Language-Test/listeningSection.js
import React, { useState, useRef, useEffect } from "react";
import AudioPlayer from "../../utils/audioPlayer";
import { normalizeOptions } from "../../utils/miscelleneous";

const ListeningSection = ({ section, flattenedQuestions = [], submitAnswer, onRequestNextSection }) => {
  const [index, setIndex] = useState(0);
  const [localAnswers, setLocalAnswers] = useState({});
  const playerRef = useRef(null);
  
  const isCompleted = (q) => {
    if (!q?.previous_answer?.answer) return false;
    const data = q.previous_answer.answer.answer_data;
    if (data?.status === "completed") return true;
    if (typeof data === "string" && data.trim() !== "") return true;
    if (typeof data === "object" && Object.keys(data).length > 0) return true;

    return false;
  };

  useEffect(() => {
    let nextIndex = index;

    while (
      nextIndex < flattenedQuestions.length &&
      isCompleted(flattenedQuestions[nextIndex])
    ) {
      nextIndex++;
    }

    if (nextIndex !== index) {
      if (nextIndex >= flattenedQuestions.length) {
        onRequestNextSection && onRequestNextSection();
      } else {
        setIndex(nextIndex);
      }
    }
  }, [section, index, flattenedQuestions]);

  useEffect(() => {
    setIndex(0);
    setLocalAnswers({});
  }, [section]);

  useEffect(() => {
    const current = flattenedQuestions[index];
    if (current?._isParent && current.content?.audio_url) {
      if (playerRef.current && playerRef.current.play) {
        try { playerRef.current.play(); } catch (e) {}
      }
    }
  }, [index])

  const current = flattenedQuestions[index];

  if (!current) return <div className="language-right-section">No questions</div>;

  const handleSelect = (assignment_question_id, opt) => {
    setLocalAnswers((s) => ({
      ...s,
      [assignment_question_id]: {
        answer_type: "multiple_choice",
        selected_option_id: opt.id,
        selected_option: `${opt.id}) ${opt.text}`
      }
    }));
  };

  const handleSubmit = () => {
    const id = current.assignment_question_id;
    const local = localAnswers[id];
    if (!local) return;

    submitAnswer({
      assignment_question_id: id,
      question_id: current.id,
      answer: {
        answer_data: local.selected_option,
      },
    });

    if (index < flattenedQuestions.length - 1) setIndex(index + 1);
    else {
      onRequestNextSection && onRequestNextSection();
    }
  };

  const handleContinueParent = () => {
    submitAnswer({
      assignment_question_id: current.assignment_question_id,
      question_id: current.id,
      answer: { answer_data: "viewed" },
    });
    setIndex(index + 1);
  };

  const idKey = current.assignment_question_id || current.id;
  const isAnswered = !!localAnswers[idKey]?.selected_option_id;
  

  return (
    <>
      <div className="language-left-section" style={{gap:'13px'}}>
        <img src="/images/speaker-gray.svg" alt="" width={56} height={56} />
        <h4 style={{marginBottom:'0'}}>Listening</h4>
        {current.content?.audio_url && (
          <>
            <p>Listen to the audio and answer the question</p>
            <AudioPlayer audioUrl={current.content.audio_url} ref={playerRef}/>
          </>
        )}
      </div>
      <div className="language-right-section">
        {current._isParent && current.content?.question_type === "listening_comprehension_set" && (
          <div className="mcq">
            <h5>{current.text}</h5>
            {current.content?.instructions && (
              <p style={{ marginBottom: "15px" }}>{current.content.instructions}</p>
            )}
            {current.content?.paragraph && (
              <div className="passage-box" style={{ marginBottom: "20px" }}>
                <p style={{ width: "450px", overflow: "auto" }}>
                  {current.content.paragraph}
                </p>
              </div>
            )}
            <button
              className="submit-btn"
              onClick={handleContinueParent}
            >
              Continue
            </button>
          </div>
        )}
        {!current._isParent && current.content?.options && (
          <div className="mcq">
            <h5>{current.text}</h5>

            <div className="option-grid">
              {normalizeOptions(current.content.options).map((opt, i) => {
                const idKey = current.assignment_question_id || current.id;
                const selected = localAnswers[idKey]?.selected_option_id === opt.id;

                return (
                  <div
                    key={i}
                    className={`opt-box ${selected ? "selected" : ""}`}
                    onClick={() => handleSelect(idKey, opt)}
                  >
                    <span className="opt-label">{opt.id}</span>
                    <span className="opt-text">{opt.text}</span>
                  </div>
                );
              })}
            </div>
            <button
              className={`submit-btn ${!isAnswered ? "disabled" : ""}`}
              disabled={!isAnswered}
              onClick={handleSubmit}
            >
              Submit
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default ListeningSection;